<template>
  <AbsPopup id="CoverPopup" title="표지 만들기" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div class="coverimg">
          <span v-if="!img">표지없음</span>
          <img v-else :src="img"/>
        </div>
        <div class="coverinfo">
          <UInput type="text" tag="li" placeholder="목차에 표시될 이름을 적어주세요" v-model="title">
            <span><b>목차 이름</b></span>
          </UInput>
          <li>
            <span class="active">권장크기 : 가로 1150px * 1623px</span>
          </li>
          <li>
            <span>jpg,png 형식의 이미지만 등록됩니다.</span>
          </li>
          <span class="line"/>
          <li>
            <span>1권 이상의 책을 만들 경우 표지마다 <u>권수 표시가 맞는지 확인해</u> 주세요</span>
          </li>
          <span class="line"/>
          <li>
            <span class="require">표지에 워터마크를 확인해 주세요</span>
          </li>
          <UbuttonList class="imageButton" tag="li" size="small" align="left" :data="buttonList"/>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import UImageLoader from '@/components/js/UImageLoader.js'

var loader = new UImageLoader()

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    if (this.option.param) {
      if (this.option.param.img) {
        this.img = this.option.param.img
      }
      if (this.option.param.name) {
        this.title = this.option.param.name
      }
    }
    loader.addForm(document.querySelector('#CoverPopup'), 'cover', (id, e) => {
      this.img = e
    })
    this.$emit('loading', false)
  },
  data () {
    return {
      buttonList: [
        {name: '삭제', state: 'deactive', click: () => { this.img = null }},
        {name: '등록', state: 'active', click: () => { loader.open('cover') }}
      ],
      title: '',
      img: null
    }
  },
  name: 'CoverPopup',
  computed: {
    returnParam () {
      if (this.title !== '' || this.img) {
        return {name: this.title, img: this.img}
      }
      return null
    }
  },
  methods: {
    removeImg () {

    },
    cutString (st) {
      return (st.length > 10) ? st.substring(0, 20) + '...' : st
    },
    submit () {
      if (this.title === '') {
        this.$emit('submit', null)
        // this.alert('목차 이름을 입력해 주세요', '107', true)
      } else {
        this.$emit('submit', this.returnParam)
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#CoverPopup {
  padding: 10px 0;
  width: 600px;
}
.popup-body {
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
  padding: 10px;
}
.coverimg {
  min-width: 230px;
  height: 324px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--line-base);
  margin-right: 10px;
}
.coverimg img {
  width: 230px;
  height: 100%;
}
.coverinfo {
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
}
.coverinfo li:first-child {
  height: 40px;
  margin-bottom: 20px;
  font-size: 1em;
  color: var(--text-title);
}
.coverinfo li {
  width: 100%;
  line-height: 20px;
  text-align: left;
  font-size: 0.9em;
  color: var(--text-description);
  padding: 0px 15px;
  display: flex;
  align-items: center;
}
.coverinfo .input span {
  margin-right: 10px;
}
.coverinfo span.line {
  width: 100%;
  border-bottom: 1px solid var(--line-base);
  margin: 20px 0px;
}
.imageButton {
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/edit/CoverPopup.vue